<template>
    <div>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="3">
                <b-form-group label="Дата с:" label-cols-md="3" class="bolded-label">
                    <date-picker
                        placeholder="Выберите дату"
                        v-model="dateFromForInput"
                        format="DD/MM/YYYY"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="Дата по:" label-cols-md="3" class="bolded-label">
                    <date-picker
                        placeholder="Выберите дату"
                        v-model="dateToForInput"
                        format="DD/MM/YYYY"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!---------------------регион------------------------->
                <b-form-group label="Регион (Область, город, район, село):" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать регион"
                        track-by="code"
                        label="text"
                        v-model="reg"
                        :options="listReg"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgRegions"
                        ref="regionRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-------------Гос. учреждение---------------------->
                <b-form-group label="Гос. учреждение:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        v-model="curComp"
                        track-by="name"
                        label="name"
                        placeholder="Выбрать гос. учреждение"
                        :options="companyBase"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgComp"
                        ref="compRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!---------------------тип бюджета------------------------->
                <b-form-group label="Тип бюджета:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать тип бюджета"
                        track-by="code"
                        label="name"
                        v-model="budget_type"
                        :options="list_budget_types"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgBudgetTypes"
                        ref="budgetTypeRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!----------------Администратор программ abp------------------->
                <b-form-group label="Администратор/Программа/Подпрограмма:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        v-model="curAbp"
                        track-by="func"
                        label="name"
                        placeholder="Выбрать адм. программ"
                        :options="abpBase"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgAbp"
                        ref="abpRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!-------------Ед. измерения---------------------->
                <b-form-group label="Единица измерения:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать единицу измерения"
                        v-model="curUnit"
                        :options="unit"
                        :custom-label="unitLabel"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        class="w-150px"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-------------Специфика---------------------->
                <b-form-group label="Специфика:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        track-by="spf"
                        label="name"
                        placeholder="Выберите специфику"
                        v-model="curSpf"
                        :options="spfBase"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        ref="spfRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
<!--        <b-row class="py-2 bb-row">-->
<!--            <b-button variant="success" @click="downloadRep" :disabled="isLoad">Скачать</b-button>-->
<!--        </b-row>-->
    </div>
</template>

<script>
import store from "../../../services/store";
import {Ax} from "@/utils";
import DatePicker from 'vue2-datepicker';

export default {
    name: "treasury-form-409",
    components: { DatePicker },
    data() {
        return {
            obl: null,

            listReg: [],
            reg: null,

            list_budget_types: [],
            budget_type: null,

            dateFrom: '',
            dateFromForInput: null,

            dateTo: '',
            dateToForInput: null,

            abpBase: [],
            curAbp: null,

            companyBase: [],
            curComp: null,

            spfBase: [],
            curSpf: null,

            languages: ['Казахский', 'Русский'],
            selectedLanguage: null,

            unit: ['tenge', 'thousand_tenge', 'million_tenge'],
            curUnit: 'tenge',

            isLoad: false,
        }
    },
    async mounted() {
        // сегодняшняя дата
        this.dateFromForInput = new Date();
        this.dateFrom = new Date().toLocaleDateString().split('.').reverse().join('-');

        // послд день текущего года
        this.dateToForInput = new Date(`${new Date().getFullYear()}-12-31`);
        this.dateTo = new Date().getFullYear() + '-12-31';
        await this.getObl();
        await this.loadCompany();
    },
    methods: {
        unitLabel(key) {
            return this.$t(`modules.budget_execution_monitoring.treasury_forms.${key}`);
        },

        async getObl() {
            try {
                await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                        // this.reg = json.region;
                    });
                await this.loadRegions();
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        },

        async loadRegions() {
            try {
                this.listReg = [];
                this.reg = null;
                if (this.dateFrom.includes('/')) {
                    this.dateFrom = this.dateFrom.split('/').reverse().join('-')
                }
                if (this.dateTo.includes('/')) {
                    this.dateTo = this.dateTo.split('/').reverse().join('-')
                }
                const response = await fetch(`/api-py/get_kod_tpk_for_409/${this.obl}/${this.dateFrom}/${this.dateTo}/${this.usrId}`);
                this.listReg = await response.json();
                if (this.listReg && this.listReg.length > 0) {
                    this.reg = this.listReg[0];
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }

            await this.chgRegions();
        }, // справочник регионов

        async chgRegions() {
            // await this.loadBudjetTypes();
            await this.loadCompany();
        },

        async loadCompany() {
            let result = [];
            this.curComp = null;
            this.companyBase = []
            try {
                if (this.reg) {
                    // result = await fetch(`/api-py/get_gu_for_409/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.budget_type.code}/${this.usrId}`)
                    result = await fetch(`/api-py/get_gu_for_409/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.usrId}`)
                        .then(response => response.json());
                    this.companyBase = result;
                }
            } catch (error) {
                this.companyBase = [];
                this.makeToast('danger', 'Ошибка загрузки Гос. учереждение', error);
            }
            const res = []
            if (result && result.length > 0) {
                for (const el of result) {
                    res.push(this.setNameLang(el, 'gu'));
                }
            }
            if (res && res.length > 1) {
                const firstElem = [{
                    name: 'Все',
                    name_ru: 'Все',
                    gu: null
                }]
                this.companyBase = firstElem.concat(res);
            } else {
                this.companyBase = res;
            }

            if (this.companyBase.length > 0) {
                this.curComp = this.companyBase[0];
            }
            await this.chgComp();
        },

        async chgComp() {
            // await this.loadAbp();
            await this.loadBudjetTypes();
        },

        async loadBudjetTypes() {
            try {
                if (this.reg) {
                    const response = await fetch(`/api-py/get_type_budjet_for_409/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.usrId}/${this.curComp.gu}`);
                    this.list_budget_types = await response.json();
                    if (this.list_budget_types && this.list_budget_types.length > 0) {
                        this.budget_type = this.list_budget_types[0];
                    }
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }

            await this.chgBudgetTypes();
        }, // справочник регионов

        async chgBudgetTypes() {
            // await this.loadCompany();
            await this.loadAbp();
        },


        async loadAbp() {
            let result = [];
            this.curAbp = null;
            this.abpBase = [];
            if (!this.curComp) {
                return;
            }
            try {
                if (this.reg && this.budget_type) {
                    result = await fetch(`/api-py/get_abp_for_409/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.budget_type.code}/${this.curComp.gu}/${this.usrId}`)
                        .then(response => response.json());
                    this.abpBase = result;
                }
            } catch (error) {
                this.abpBase = [];
                this.makeToast('danger', 'Ошибка загрузки Адм. программа', error);
            }
            const res = []
            for (const el of result) {
                res.push(this.setNameLang(el, 'func'));
            }
            if (res && res.length > 1) {
                const firstElem = [{
                    name: 'Все',
                    name_ru: 'Все',
                    func: null
                }]
                this.abpBase = firstElem.concat(res);
            } else {
                this.abpBase = res;
            }

            if (this.abpBase.length > 0) {
                this.curAbp = this.abpBase[0];
            }
            await this.chgAbp();
        },

        async chgAbp() {
            await this.loadSpec();
        },

        async loadSpec() {
            let result = [];
            this.curSpf = null;
            this.spfBase = []
            if (!this.curAbp) {
                return;
            }
            try {
                if (this.reg && this.budget_type) {
                    result = await fetch(`/api-py/get_spf_for_409/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.budget_type.code}/${this.curAbp.func}/${this.curComp.gu}/${this.usrId}`)
                        .then(response => response.json());
                    this.spfBase = result;
                }
            } catch (error) {
                this.spfBase = [];
                this.makeToast('danger', 'Ошибка загрузки Специфика', error);
            }
            const res = []
            for (const el of result) {
                res.push(this.setNameLang(el, 'spf'));
            }
            if (res && res.length > 1) {
                const firstElem = [{
                    name: 'Все',
                    name_ru: 'Все',
                    spf: null
                }]
                this.spfBase = firstElem.concat(res);
            } else {
                this.spfBase = res;
            }

            if (this.spfBase.length > 0) {
                this.curSpf = this.spfBase[0];
            }
        },

        setNameLang(obj, codeName) {
            let txt = obj['name_' + this.$i18n.locale];
            if (txt === undefined) {
                txt = obj.name_ru;
            }
            if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                txt = obj[codeName] + ' - ' + txt;
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            return el;
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },

        downloadRep() {
            try {
                if (
                    !(this.reg && this.reg.hasOwnProperty('code') && this.reg.code) ||
                    !(this.budget_type && this.budget_type.hasOwnProperty('code') && this.budget_type.code) ||
                    !(this.curUnit) ||
                    !(this.dateFrom) ||
                    !(this.dateTo)
                ) {
                    this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
                    this.$emit('onDownload', 0)
                    return
                }
                this.makeToast('info', this.$i18n.t('modules.execution.attention')
                    , this.$i18n.t('modules.execution.treasury_forms_informative_message'));
                this.isLoad = true
                const filter = {
                    region: this.reg.code,
                    budgetType: this.budget_type.code,
                    budgetTypeName: this.budget_type.name,
                    unit: this.curUnit,
                    locale: this.$i18n.locale,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    abp: this.curAbp.func,
                    abpName: this.curAbp.name,
                    gu: this.curComp.gu,
                    guName: this.curComp.name,
                    specific: this.curSpf.spf,
                    specificNameRu: this.curSpf.name_ru,
                    user_id: this.usrId,
                };
                Ax(
                    {
                        url: '/api-py/treasury-form-xls-rep-409',
                        method: 'POST',
                        responseType: 'blob',
                        data: filter
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Форма 04-09.xlsx');// or any other extension
                        this.$emit('onDownload', 100)
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                        this.$emit('onDownload', 0)
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
                this.$emit('onDownload', 0)
            } finally {
                this.isLoad = false
            }
        },
    },
    watch: {
        async dateFromForInput() {
            this.dateFrom = `${this.dateFromForInput.getFullYear()}-${this.dateFromForInput.getMonth() + 1}-${this.dateFromForInput.getDate()}`
            await this.loadRegions();
        },
        async dateToForInput() {
            this.dateTo = `${this.dateToForInput.getFullYear()}-${this.dateToForInput.getMonth() + 1}-${this.dateToForInput.getDate()}`
            await this.loadRegions();
        }
    },
    computed: {
        usrId() {
            if (!store.state.user.sub) { return null; }
            return store.state.user.sub;
        }
    }
}
</script>

<style scoped>

</style>